const RadioCheckboxCheckedSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12Z"
      fill="white"
      className="stroke-field-checked-radio"
    />
    <circle cx="12" cy="12" r="6" className="fill-field-checked-radio" />
  </svg>
)
export { RadioCheckboxCheckedSvg }
